<h2>Select Basic Examples</h2>

<div class="select-grid">
	<div class="select-column">
		<span class="label">Select básico</span>
		<app-select
			[formControl]="selectControl"
			[options]="countryOptions"
			placeholder="Selecciona un país..."
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'selectControl', options: 'countryOptions', placeholder: 'Selecciona un país...', size: 'large'})" />
	</div>

	<div class="select-column">
		<span class="label">Select con búsqueda</span>
		<app-select
			[formControl]="selectControl"
			[options]="countryOptions"
			placeholder="Selecciona un país..."
			[filter]="true"
			filterPlaceholder="Buscar países..."
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'selectControl', options: 'countryOptions', placeholder: 'Selecciona un país...', size: 'large', filter: true, filterPlaceholder: 'Buscar países...'})" />
	</div>

</div>

<h2>Select Sizes</h2>

<div class="size-grid">
	<div class="size-column">
		<span class="label">Large (64px)</span>
		<app-select
			[formControl]="selectControl"
			[options]="countryOptions"
			label="País"
			size="large"
			placeholder="Selecciona un país..."
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'selectControl', options: 'countryOptions', label: 'País', size: 'large', placeholder: 'Selecciona un país...'})" />
	</div>

	<div class="size-column">
		<span class="label">Medium (56px)</span>
		<app-select
			[formControl]="selectControl"
			[options]="countryOptions"
			label="País"
			size="medium"
			placeholder="Selecciona un país..."
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'selectControl', options: 'countryOptions', label: 'País', size: 'medium', placeholder: 'Selecciona un país...'})" />
	</div>

	<div class="size-column">
		<span class="label">Small (48px)</span>
		<app-select
			[formControl]="selectControl"
			[options]="countryOptions"
			label="País"
			size="small"
			placeholder="Selecciona un país..."
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'selectControl', options: 'countryOptions', label: 'País', size: 'small', placeholder: 'Selecciona un país...'})" />
	</div>
</div>

<h2>Select States</h2>

<div class="size-grid">
	<div class="size-column">
		<span class="label">Normal</span>
		<app-select
			[formControl]="selectControl"
			[options]="countryOptions"
			label="País"
			placeholder="Selecciona un país..."
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'selectControl', options: 'countryOptions', label: 'País', placeholder: 'Selecciona un país...', size: 'large'})" />
	</div>

	<div class="size-column">
		<span class="label">Disabled</span>
		<app-select
			[formControl]="disabledSelectControl"
			[options]="countryOptions"
			label="País"
			placeholder="Selecciona un país..."
			[disabled]="true"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'disabledSelectControl', options: 'countryOptions', label: 'País', placeholder: 'Selecciona un país...', size: 'large', disabled: true})" />
	</div>

	<div class="size-column">
		<span class="label">Error</span>
		<app-select
			[formControl]="errorSelectControl"
			[options]="countryOptions"
			label="País"
			placeholder="Selecciona un país..."
			[error]="true"
			errorMessage="Este campo es obligatorio"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'errorSelectControl', options: 'countryOptions', label: 'País', placeholder: 'Selecciona un país...', size: 'large', error: true, errorMessage: 'Este campo es obligatorio'})" />
	</div>
</div>

<h2>Select with Search/Filter</h2>

<div class="size-grid">
	<div class="size-column">
		<span class="label">Large con búsqueda</span>
		<app-select
			[formControl]="selectControl"
			[options]="countryOptions"
			label="País"
			placeholder="Seleccionar país..."
			size="large"
			[filter]="true"
			filterPlaceholder="Buscar países..."
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'selectControl', options: 'countryOptions', label: 'País', placeholder: 'Seleccionar país...', size: 'large', filter: true, filterPlaceholder: 'Buscar países...'})" />
	</div>

	<div class="size-column">
		<span class="label">Medium con búsqueda</span>
		<app-select
			[formControl]="selectControl"
			[options]="countryOptions"
			label="País"
			placeholder="Seleccionar país..."
			size="medium"
			[filter]="true"
			filterPlaceholder="Buscar países..."
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'selectControl', options: 'countryOptions', label: 'País', placeholder: 'Seleccionar país...', size: 'medium', filter: true, filterPlaceholder: 'Buscar países...'})" />
	</div>

	<div class="size-column">
		<span class="label">Small con búsqueda</span>
		<app-select
			[formControl]="selectControl"
			[options]="countryOptions"
			label="País"
			placeholder="Seleccionar país..."
			size="small"
			[filter]="true"
			filterPlaceholder="Buscar países..."
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'selectControl', options: 'countryOptions', label: 'País', placeholder: 'Seleccionar país...', size: 'small', filter: true, filterPlaceholder: 'Buscar países...'})" />
	</div>
</div>